import { render, staticRenderFns } from "./OrgMonitoring.vue?vue&type=template&id=caa130d4&scoped=true&"
import script from "./OrgMonitoring.vue?vue&type=script&lang=js&"
export * from "./OrgMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa130d4",
  null
  
)

export default component.exports